










import Vue from "vue"
export default Vue.extend({
  props: {
    positionCenter: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: String,
      default: null,
    },
    isFullWidth: {
      type: Boolean,
      default: false,
    },
  },
})
